import React, { useState } from "react";
import "./RightSidebar.css";
import { useSelector, useDispatch } from "react-redux";
import {
    deleteUserActivityElements, updateSelectedComponent, updateUserActivity,
    updateUserActivityBackground, updateUserActivityElements
} from '../../redux/slices/userActivity';
import ColorEditor from "./Styles/ColorEditor/ColorEditor";
import FontFamily from "./Styles/fontFamily";
import FontSize from "./Styles/fontSize";
import FontWeight from "./Styles/fontWeight";
import FontStyles from "./Styles/fontStyles";
import BGColorEditor from "./Styles/BGColorEditor/BGColorEditor";
import Border from "./Styles/border";
import Margin from "./Styles/margin";
import Padding from "./Styles/padding";
import Upload from "./Styles/upload";
import BorderRadius from "./Styles/borderRadius";
// import { frontendUrl } from "../../services/constants";
import ButtonAction from "./Properties/buttonAction";
import Requiredfield from "./Properties/requiredfield";
import MinMaxLength from "./Properties/minMaxLength";
import SlideBGColorEditor from "./Styles/SlideBGColorEditor/SlideBGColorEditor";
import AnimationSetting from "./AnimationSetting/AnimationSetting";
import HoverColorEditor from "./Styles/HoverColorEditor/HoverColorEditor";
import HoverBGColorEditor from "./Styles/HoverBGColorEditor/HoverBGColorEditor";
import HoverBorder from "./Styles/Hoverborder";
import UploadImages from "./Styles/uploadImages";
import Layers from "./Styles/Layers";
import OptionsProperty from "./Properties/optionsProperty";
import MaxLength from "./Properties/maxLength";
import ImageWidth from "./Styles/imageWidth";
import ImagePadding from "./Styles/imagePadding";
import ImagePosition from "./Styles/imagePosition";
import RatingType from "./Properties/ratingType";
import SelectedBGColorEditor from "./Styles/SelectedBGColorEditor/SelectedBGColorEditor";
import VideoUrl from "./Properties/VideoUrl";
import Timer from "./Properties/timer";
import FieldPosition from "./Properties/fieldPosition";
import LabelText from "./Properties/labelText";
import AudioUpload from "./Properties/audioUpload";
import Placeholder from "./Properties/placeholder";
import BottomBorder from "./Styles/bottomBorder";
import LinkUrl from "./Properties/linkUrl";
import Gap from "./Styles/gap";
import LabelFontSize from "./Styles/labelFontSize";
import LabelFontWeight from "./Styles/labelFontWeight";
import LabelColorEditor from "./Styles/LabelColorEditor/LabelColorEditor";
import Size from "./Properties/size";
import ImageOptionsProperty from "./Properties/imageOptionsProperty";
import Height from "./Styles/height";
import FrontText from "./Properties/FrontText";
import BackText from "./Properties/BackText";
import OptionQuestion from "./Properties/optionQuestion";
import IframeUrl from "./Properties/IframeUrl";
import OpenEnded from "./Properties/openEnded";
import VideoUpload from "./Properties/videoUpload";
import ImageMultiOptionsProperty from "./Properties/imageMultiOptionsProperty";
import DescriptionFontSize from "./Styles/descriptionFontSize";
import DescriptionFontWeight from "./Styles/descriptionFontWeight";
import DescriptionColorEditor from "./Styles/DescriptionColorEditor/DescriptionColorEditor";
import Description2FontSize from "./Styles/description2FontSize";
import Description2FontWeight from "./Styles/description2FontWeight";
import Description2ColorEditor from "./Styles/Description2ColorEditor/Description2ColorEditor";
import AttributeOptionsProperty from "./Properties/AttributeOptionsProperty";
import ShowAttribute from "./Properties/showAttribute";
import ChangeElement from "./Properties/ChangeElement";
import "intro.js/introjs.css";
import NpsPositiveNegativeText from "./Properties/npsPositiveNegativeText";

const RightSidebar = () => {
    const dispatch = useDispatch();
    const { userActivities, selectedUserActivity, selectedComponent } = useSelector((state) => state.userActivity);

    const [selectedTab, setselectedTab] = useState(1);
    const [appliedSlideBackground, setappliedSlideBackground] = useState(false);
    const [appliedButton, setappliedButton] = useState(false);

    const handelSelectTab = (num) => {
        // console.log("tab", num)
        setselectedTab(num);
    }
    const handelElementDelete = () => {
        dispatch(
            deleteUserActivityElements({
                selectedActivityIdx: selectedUserActivity,
                selectedElementIdx: selectedComponent.target_id,
            })
        );
        dispatch(
            updateSelectedComponent({
                type: "Slide",
                name: "Container",
                target: "",
                target_id: null,
            })
        );
    }

    const handelBgImageDelete = () => {
        dispatch(
            updateUserActivity({
                backgroundImage: "",
            })
        );
    }

    const handelApplyAllBackground = () => {
        const bgImg = userActivities[selectedUserActivity].backgroundImage;
        const bgColor = userActivities[selectedUserActivity].backgroundColor;

        userActivities.map((item, i) => {
            dispatch(
                updateUserActivityBackground({
                    selectedActivityIdx: i,
                    backgroundImage: bgImg,
                    backgroundColor: bgColor,
                })
            );
        })

        setappliedSlideBackground(true);

        setTimeout(() => {
            setappliedSlideBackground(false);
        }, 2000); //miliseconds
    }

    const handelApplyAllButton = () => {
        let copyTempElement = userActivities[selectedUserActivity].elements[selectedComponent.target_id];
        const copyElementAttrib = copyTempElement?.elementAttributes;
        const copyElementHoverAttrib = copyTempElement?.elementHoverAttributes;

        // console.log(copyTempElement)

        userActivities.map((activity, i) => {
            activity.elements.map((item, j) => {
                let tempElement = item;
                // console.log(tempElement)
                if (item.elementType === "Button") {

                    // console.log("Button")

                    tempElement = {
                        ...tempElement,
                        elementAttributes: {
                            ...copyElementAttrib,
                            text: tempElement?.elementAttributes?.text,
                        },
                        elementHoverAttributes: {
                            ...copyElementHoverAttrib,
                            text: tempElement?.elementHoverAttributes?.text,
                        },
                    };

                    dispatch(
                        updateUserActivityElements({
                            selectedActivityIdx: i,
                            selectedElementIdx: j,
                            element: tempElement,
                        })
                    );
                }

            })
        })

        setappliedButton(true);

        setTimeout(() => {
            setappliedButton(false);
        }, 2000); //miliseconds
    }

    const handelApplyAllText = () => {
        let copyTempElement = userActivities[selectedUserActivity].elements[selectedComponent.target_id];
        const copyElementAttrib = copyTempElement?.elementAttributes;

        // console.log(copyTempElement)

        userActivities.map((activity, i) => {
            activity.elements.map((item, j) => {
                let tempElement = item;
                // console.log(tempElement)
                if (item.elementType === "Text") {

                    console.log("Text")

                    tempElement = {
                        ...tempElement,
                        elementAttributes: {
                            ...copyElementAttrib,
                            text: tempElement?.elementAttributes?.text,
                            formattedText: tempElement?.elementAttributes?.formattedText,
                        },
                    };

                    dispatch(
                        updateUserActivityElements({
                            selectedActivityIdx: i,
                            selectedElementIdx: j,
                            element: tempElement,
                        })
                    );
                }

            })
        })

        setappliedButton(true);

        setTimeout(() => {
            setappliedButton(false);
        }, 2000); //miliseconds
    }

    const handelApplyAllOptionType = () => {
        let copyTempElement = userActivities[selectedUserActivity].elements[selectedComponent.target_id];
        const copyElementAttrib = copyTempElement?.elementAttributes;
        const copyElementHoverAttrib = copyTempElement?.elementHoverAttributes;

        // console.log(copyTempElement)

        userActivities.map((activity, i) => {
            activity.elements.map((item, j) => {
                let tempElement = item;
                const elementAttrib = tempElement?.elementAttributes;
                // console.log(tempElement)
                if (item.elementType === "Checkbox" || item.elementType === "CheckboxGroup" || item.elementType === "CheckboxImage" || item.elementType === "RadioGroup" || item.elementType === "RadioImage" || item.elementType === "Matrix" || item.elementType === "Mcq" || item.elementType === "McqImage" || item.elementType === "Reorder" || item.elementType === "ReorderImage") {

                    // console.log("Text")

                    tempElement = {
                        ...tempElement,
                        elementAttributes: {
                            ...elementAttrib,
                            ...(elementAttrib?.color && { color: copyElementAttrib?.color }),
                            ...(elementAttrib?.fontFamily && { fontFamily: copyElementAttrib?.fontFamily }),
                            ...(elementAttrib?.fontWeight && { fontWeight: copyElementAttrib?.fontWeight }),
                            ...(elementAttrib?.fontSize && { fontSize: copyElementAttrib?.fontSize }),
                            ...(elementAttrib?.backgroundColor && { backgroundColor: copyElementAttrib?.backgroundColor }),
                            ...(elementAttrib?.textAlign && { textAlign: copyElementAttrib?.textAlign }),
                            ...(elementAttrib?.borderRadius && { borderRadius: copyElementAttrib?.borderRadius }),
                            ...(elementAttrib?.labelFontSize && { labelFontSize: copyElementAttrib?.labelFontSize }),
                            ...(elementAttrib?.labelFontWeight && { labelFontWeight: copyElementAttrib?.labelFontWeight }),
                            ...(elementAttrib?.labelColor && { labelColor: copyElementAttrib?.labelColor }),
                        },
                        elementHoverAttributes: {
                            ...copyElementHoverAttrib,
                        },
                    };

                    dispatch(
                        updateUserActivityElements({
                            selectedActivityIdx: i,
                            selectedElementIdx: j,
                            element: tempElement,
                        })
                    );
                }

            })
        })

        setappliedButton(true);

        setTimeout(() => {
            setappliedButton(false);
        }, 2000); //miliseconds
    }

    return (
        <>
            <div className="RightSidebarMainContainer" data-intro="Here you can check the properties of each elements and customize as per your needs.">
                <div className="RightSidebarElementProperties">
                    <div><b style={{ color: "#6c7589", paddingRight: "5px" }}>Element:</b> {selectedComponent.name}</div>

                    {selectedComponent.type !== "Slide" && <button className="ElementDelete"
                        onClick={() => handelElementDelete()}>
                        <i className="fa fa-trash-o" aria-hidden="true"></i> Delete</button>}
                </div>
                <div className="LeftSidebarContainer" style={{ borderTop: "2px solid #dbdfe8" }}>
                    <div className="LeftSidebarTab" onClick={() => handelSelectTab(1)}>Properties
                        {selectedTab === 1 && <div className="selected-line"></div>}
                    </div>
                    <div className="LeftSidebarTab" onClick={() => handelSelectTab(2)}>Styles
                        {selectedTab === 2 && <div className="selected-line"></div>}
                    </div>
                    <div className="LeftSidebarTab" onClick={() => handelSelectTab(3)}>Animations
                        {selectedTab === 3 && <div className="selected-line"></div>}
                    </div>
                </div>
                <div className="RightSidebarContainer">

                    {selectedTab === 1 && <>
                        {selectedComponent.type === "Slide" && (
                            <>
                                <Timer />

                            </>
                        )}
                        {selectedComponent.type === "Button" && (
                            <>
                                <ButtonAction />

                            </>
                        )}

                        {selectedComponent.type === "Image" && (
                            <>
                                <LinkUrl />
                            </>
                        )}

                        {(selectedComponent.type === "TextField" || selectedComponent.type === "TextArea" || selectedComponent.type === "Email" || selectedComponent.type === "Password" || selectedComponent.type === "Phone" || selectedComponent.type === "NumberField") && (
                            <>
                                <Requiredfield />
                                <MinMaxLength />
                                <FieldPosition />
                                <Placeholder />

                            </>
                        )}
                        {(selectedComponent.type === "QuestionAnswer") && (
                            <>
                                <ChangeElement />
                                <Requiredfield />
                                <OpenEnded />
                                {/* <MinMaxLength /> */}
                                <Placeholder />

                            </>
                        )}
                        {(selectedComponent.type === "Checkbox") && (
                            <>
                                <LabelText />
                                <ChangeElement />
                                <Requiredfield />
                                <OptionsProperty />
                                <FieldPosition />
                            </>
                        )}
                        {(selectedComponent.type === "CheckboxGroup") && (
                            <>
                                <LabelText />
                                <ChangeElement />
                                <Requiredfield />
                                <OpenEnded />
                                <MaxLength />
                                <OptionsProperty />
                                <FieldPosition />
                            </>
                        )}
                        {(selectedComponent.type === "RadioGroup") && (
                            <>
                                <LabelText />
                                <ChangeElement />
                                <Requiredfield />
                                <OpenEnded />
                                <OptionsProperty />
                                <FieldPosition />

                            </>
                        )}
                        {(selectedComponent.type === "Matrix") && (
                            <>
                                <Requiredfield />
                                <LabelText />
                                <OptionQuestion />


                            </>
                        )}
                        {(selectedComponent.type === "CheckboxImage") && (
                            <>
                                <LabelText />
                                <ChangeElement />
                                <MaxLength />
                                <OpenEnded />
                                <ImageOptionsProperty />
                                <ImageWidth />
                                <ImagePadding />
                                <FieldPosition />

                            </>
                        )}
                        {(selectedComponent.type === "RadioImage") && (
                            <>
                                <LabelText />
                                <ChangeElement />
                                <OpenEnded />
                                <Requiredfield />
                                <ImageOptionsProperty />
                                <ImageWidth />
                                <ImagePadding />
                                <FieldPosition />

                            </>
                        )}
                        {(selectedComponent.type === "RadioMultiImage") && (
                            <>
                                <LabelText />
                                <ChangeElement />
                                <Requiredfield />
                                <OpenEnded />
                                <ImageMultiOptionsProperty />
                                <ImageWidth />
                                <ImagePadding />
                                <FieldPosition />

                            </>
                        )}
                        {(selectedComponent.type === "Rating") && (
                            <>
                                <LabelText />
                                <RatingType />
                                <MaxLength />
                                <Size />

                            </>
                        )}
                        {(selectedComponent.type === "Nps") && (
                            <>
                                <LabelText />
                                <ChangeElement />
                                <Requiredfield />
                                <OpenEnded />
                                <MaxLength />
                                <NpsPositiveNegativeText />
                                <Size />

                            </>
                        )}
                        {(selectedComponent.type === "Mcq") && (
                            <>
                                <LabelText />
                                <OptionsProperty />

                            </>
                        )}
                        {(selectedComponent.type === "McqImage") && (
                            <>
                                <LabelText />
                                <ImageOptionsProperty />
                                <ImageWidth />
                                <ImagePadding />
                                <FieldPosition />

                            </>
                        )}
                        {(selectedComponent.type === "Reorder") && (
                            <>
                                <LabelText />
                                <OptionsProperty />

                            </>
                        )}
                        {(selectedComponent.type === "ReorderImage") && (
                            <>
                                <LabelText />
                                <ImageOptionsProperty />
                                <ImageWidth />
                                <ImagePadding />
                                <FieldPosition />

                            </>
                        )}
                        {(selectedComponent.type === "Video") && (
                            <>
                                <VideoUrl />
                                <div style={{ width: "100%", textAlign: "center", margin: "1rem", fontSize: "1rem", fontWeight: "400" }}>OR</div>
                                <VideoUpload />

                            </>
                        )}
                        {(selectedComponent.type === "Audio") && (
                            <>
                                <AudioUpload />

                            </>
                        )}
                        {selectedComponent.type === "Iframe" && (
                            <>
                                <IframeUrl />
                            </>
                        )}

                        {(selectedComponent.type === "Dropdown" || selectedComponent.type === "DropdownMultiselect") && (
                            <>
                                <Requiredfield />
                                <OptionsProperty />
                                <FieldPosition />

                            </>
                        )}

                        {(selectedComponent.type === "DateField" || selectedComponent.type === "FileUpload") && (
                            <>
                                <Requiredfield />
                                <FieldPosition />

                            </>
                        )}

                        {(selectedComponent.type === "FlipCard") && (
                            <>
                                <LabelText />
                                <FrontText />
                                <BackText />

                            </>
                        )}

                        {(selectedComponent.type === "GenericConjoint" || selectedComponent.type === "BestWorstConjoint") && (
                            <>
                                <LabelText />
                                <ShowAttribute />
                                <AttributeOptionsProperty />
                                <ImageWidth />
                                <ImagePadding />

                            </>
                        )}

                    </>}
                    {selectedTab === 2 && <>
                        {selectedComponent.type === "Slide" && (
                            <>
                                <div style={{
                                    width: "100%", textAlign: "left", margin: "1rem", fontSize: "1rem", fontWeight: "700",
                                    display: "flex", justifyContent: "space-between", alignItems: "center"
                                }}>Slide Background
                                    {(selectedComponent.type === "Slide" && userActivities[selectedUserActivity]?.backgroundImage) &&
                                        <button className="ElementDelete"
                                            onClick={() => handelBgImageDelete()}>
                                            <i className="fa fa-trash-o" aria-hidden="true"></i>  Delete Background
                                        </button>}
                                </div>

                                <Upload />
                                <UploadImages />
                                <SlideBGColorEditor />

                                <div style={{}}>
                                    <button type='submit' className='ApplyAllBgBtn' onClick={() => handelApplyAllBackground()}>
                                        {appliedSlideBackground ? "Applied" : "Apply To All Steps"}</button>
                                </div>

                            </>
                        )}
                        {selectedComponent.type === "Text" && (
                            <>
                                <div style={{}}>
                                    <button type='submit' className='ApplyAllBgBtn' onClick={() => handelApplyAllText()}>
                                        {appliedButton ? "Applied" : "Apply To All Text"}</button>
                                </div>

                                <ColorEditor />
                                <BGColorEditor />
                                <FontFamily />
                                <FontSize />
                                <FontWeight />
                                <FontStyles />
                                <Layers />
                                <Border />
                                <BorderRadius />
                                <Margin />
                                <Padding />

                            </>
                        )}
                        {selectedComponent.type === "Image" && (
                            <>
                                <Upload />
                                <UploadImages />
                                <Border />
                                <BorderRadius />
                                <Layers />
                                <Margin />
                                <Padding />
                            </>
                        )}
                        {selectedComponent.type === "Video" && (
                            <>
                                <Border />
                                <Layers />
                                <Margin />
                                <Padding />
                            </>
                        )}
                        {selectedComponent.type === "Audio" && (
                            <>
                                <Border />
                                <Layers />
                                <Margin />
                                <Padding />
                            </>
                        )}
                        {selectedComponent.type === "Iframe" && (
                            <>
                                <Border />
                                <Layers />
                                <Margin />
                                <Padding />
                            </>
                        )}
                        {selectedComponent.type === "Button" && (
                            <>
                                <div style={{}}>
                                    <button type='submit' className='ApplyAllBgBtn' onClick={() => handelApplyAllButton()}>
                                        {appliedButton ? "Applied" : "Apply To All Buttons"}</button>
                                </div>

                                <ColorEditor />
                                <BGColorEditor />
                                <HoverColorEditor />
                                <HoverBGColorEditor />
                                <FontFamily />
                                <FontSize />
                                <FontWeight />
                                <FontStyles />
                                <Layers />
                                <Border />
                                <HoverBorder />
                                <BorderRadius />
                                <Margin />
                                <Padding />

                                <div style={{ width: "100%", textAlign: "left", margin: "1rem", fontSize: "1.2rem", fontWeight: "800" }}>Image</div>

                                <Upload />
                                <UploadImages />
                                <ImageWidth />
                                <ImagePadding />
                                <ImagePosition />

                            </>
                        )}
                        {(selectedComponent.type === "TextField" || selectedComponent.type === "TextArea" || selectedComponent.type === "Email" || selectedComponent.type === "Password" || selectedComponent.type === "Phone" || selectedComponent.type === "NumberField" || selectedComponent.type === "DateField" || selectedComponent.type === "FileUpload") && (
                            <>
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Label Styles - </p>
                                <ColorEditor />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Input Field Styles - </p>
                                <BGColorEditor />
                                <Height />
                                <Border />
                                <BottomBorder />
                                <BorderRadius />
                                <Gap />
                                <Margin />
                                <Padding />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>General Styles - </p>
                                <FontFamily />
                                <FontSize />
                                <Layers />
                                <FontWeight />
                                <FontStyles />
                            </>
                        )}

                        {(selectedComponent.type === "QuestionAnswer") && (
                            <>
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Label Styles - </p>
                                <ColorEditor />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Answer Field Styles - </p>
                                <Height />
                                <BGColorEditor />
                                <Border />
                                <BottomBorder />
                                <BorderRadius />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>General Styles - </p>
                                <FontFamily />
                                <FontSize />
                                <FontWeight />
                                <FontStyles />
                                <Margin />
                                <Padding />
                                <Layers />
                            </>
                        )}


                        {(selectedComponent.type === "Rating") && (
                            <>
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Label Styles - </p>
                                <ColorEditor />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Answer Field Styles - </p>
                                <BGColorEditor />
                                <HoverBGColorEditor />
                                <SelectedBGColorEditor />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>General Styles - </p>
                                <FontFamily />
                                <FontSize />
                                <FontWeight />
                                <FontStyles />
                                <Margin />
                                <Padding />
                                <Gap />
                                <Border />
                                <BorderRadius />
                                <Layers />
                            </>
                        )}

                        {(selectedComponent.type === "Nps") && (
                            <>
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Label Styles - </p>
                                <LabelColorEditor />
                                <LabelFontWeight />
                                <ColorEditor />
                                <LabelFontSize />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Answer Field Styles - </p>
                                <FontSize />
                                <FontWeight />
                                <Border />
                                <BorderRadius />
                                <Margin />
                                <Padding />
                                <BGColorEditor />
                                <HoverBGColorEditor />
                                <SelectedBGColorEditor />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>General Styles - </p>
                                <FontFamily />
                                <FontStyles />
                                <Gap />
                                <Layers />
                            </>
                        )}

                        {(selectedComponent.type === "Checkbox" || selectedComponent.type === "CheckboxGroup" || selectedComponent.type === "CheckboxImage" || selectedComponent.type === "RadioGroup" || selectedComponent.type === "RadioImage" || selectedComponent.type === "Matrix" || selectedComponent.type === "Mcq" || selectedComponent.type === "McqImage" || selectedComponent.type === "Reorder" || selectedComponent.type === "ReorderImage") && (
                            <>
                                <div style={{}}>
                                    <button type='submit' className='ApplyAllBgBtn' onClick={() => handelApplyAllOptionType()}>
                                        {appliedButton ? "Applied" : "Apply To All Option Type Element"}</button>
                                </div>

                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Label Styles - </p>
                                <LabelColorEditor />
                                <LabelFontSize />
                                <LabelFontWeight />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Option Field Styles - </p>
                                <FontSize />
                                <FontWeight />
                                <ColorEditor />
                                <BGColorEditor />
                                <HoverColorEditor />
                                <HoverBGColorEditor />
                                <Border />
                                <HoverBorder />
                                <BorderRadius />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>General Styles - </p>
                                <FontStyles />
                                <Layers />
                                <FontFamily />
                                <Gap />
                                <Margin />
                                <Padding />

                            </>
                        )}
                        {(selectedComponent.type === "RadioMultiImage") && (
                            <>
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Label Styles - </p>
                                <LabelColorEditor />
                                <LabelFontSize />
                                <LabelFontWeight />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Option Field Styles - </p>
                                <ColorEditor />
                                <BGColorEditor />
                                <HoverColorEditor />
                                <HoverBGColorEditor />
                                <HoverBorder />
                                <Margin />
                                <Padding />
                                <Border />
                                <BorderRadius />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>General Styles - </p>
                                <FontFamily />
                                <FontSize />
                                <FontWeight />
                                <FontStyles />
                                <Gap />
                                <Layers />


                                <div style={{ width: "100%", textAlign: "left", margin: "1rem", fontSize: "1.2rem", fontWeight: "800" }}>Description</div>

                                <DescriptionColorEditor />
                                <DescriptionFontSize />
                                <DescriptionFontWeight />
                                <Description2ColorEditor />
                                <Description2FontSize />
                                <Description2FontWeight />
                            </>
                        )}

                        {(selectedComponent.type === "Dropdown" || selectedComponent.type === "DropdownMultiselect") && (
                            <>
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Label Styles - </p>
                                <ColorEditor />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Oprion Field Styles - </p>

                                <BGColorEditor />
                                <Border />
                                <BorderRadius />
                                <Padding />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>General Styles - </p>

                                <Margin />
                                <FontFamily />
                                <FontSize />
                                <FontWeight />
                                <FontStyles />
                                <Gap />
                                <Layers />



                            </>
                        )}

                        {(selectedComponent.type === "FlipCard") && (
                            <>

                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Label Styles - </p>
                                <LabelColorEditor />
                                <LabelFontSize />
                                <LabelFontWeight />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />

                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Front Card Styles - </p>

                                <ColorEditor />
                                <BGColorEditor />
                                <Border />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Back Card Styles - </p>

                                <HoverColorEditor />
                                <HoverBGColorEditor />
                                <HoverBorder />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Card Styles - </p>
                                <FontSize />
                                <FontWeight />
                                <BorderRadius />
                                <Margin />
                                <Padding />

                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>General Styles - </p>
                                <FontStyles />
                                <Layers />
                                <FontFamily />
                                <Gap />

                            </>
                        )}

                        {(selectedComponent.type === "GenericConjoint" || selectedComponent.type === "BestWorstConjoint") && (
                            <>
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Label Styles - </p>
                                <LabelColorEditor />
                                <LabelFontSize />
                                <LabelFontWeight />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>Option Field Styles - </p>
                                <ColorEditor />
                                <BGColorEditor />
                                <HoverColorEditor />
                                <HoverBGColorEditor />
                                <HoverBorder />
                                <Margin />
                                <Padding />
                                <Border />
                                <BorderRadius />
                                <hr style={{ border: '0.5px solid #9e9e9e33', margin: '20px 0px 0px 0px', width: '100%' }} />
                                <p style={{
                                    textAlign: 'left',
                                    padding: '15px',
                                    width: '100%',
                                    color: '#3184c9'
                                }}>General Styles - </p>
                                <FontFamily />
                                <FontSize />
                                <FontWeight />
                                <FontStyles />
                                <Gap />
                                <Layers />

                            </>
                        )}

                    </>}
                    {selectedTab === 3 && <AnimationSetting />}
                </div>
            </div>
        </>
    );
}

export default RightSidebar;